export default __webpack_public_path__ + "static/media/kotlin.ce7dfda3.svg";